<!--
 * @Descripttion : 省市区选择器
 * @version      : 
 * @Author       : ml
 * @Date         : 2020-09-07 17:41:37
 * @LastEditors  : ml
 * @LastEditTime : 2020-09-08 09:49:30
-->
<template>
  <a-cascader :options="options" v-model="defaultProvinceCity" :placeholder="placeholder" :fieldNames="{ label: 'name', value: 'id', children: 'values' }" @change="onChange" />
</template>

<script>
import { GetProvinceAndCityAndAreaList } from "@/api/saasV5";
const CACHE_KEY = 'region_data_cache';
const CACHE_EXPIRY_KEY = 'region_data_cache_expiry';
const CACHE_DURATION = 3 * 30 * 24 * 60 * 60 * 1000; // 3个月的毫秒数
export default {
  props: {
    placeholder: {
      type: String,
      default: "请选择地址"
    },
    selectedProvinceCity: {
      type: Array,
      default: null
    }
  },
  watch: {
    selectedProvinceCity(o, n) {
      console.log(o, n);
      this.defaultProvinceCity = this.selectedProvinceCity;
    }
  },
  data() {
    return {
      options: [],
      defaultProvinceCity: null
    };
  },
  mounted() {
    const cachedData = this.getCachedRegionData();
    if (cachedData) {
      this.$nextTick(() => {
        this.options = cachedData;
      });
    } else {
      GetProvinceAndCityAndAreaList({
        json: true
      }).then(res => {
        this.setCachedRegionData(res.data); // 缓存数据
        this.$nextTick(() => {
          this.options = res.data;
        });
      });
    }

  },
  methods: {
    onChange(value, selectedOptions) {
      // 选中数据返回给父级
      console.log(value, selectedOptions);
      if (selectedOptions) {
        this.$emit("change", selectedOptions);
      }
    },
    // 获取缓存数据
    getCachedRegionData() {
      try {
        const cachedData = localStorage.getItem(CACHE_KEY);
        const expiryTime = localStorage.getItem(CACHE_EXPIRY_KEY);
        if (cachedData && expiryTime && Date.now() < Number(expiryTime)) {
          return JSON.parse(decodeURIComponent(cachedData));
        }
        return null;
      } catch (error) {
        console.warn('解析失败，清理缓存:', error);
        clearRegionCache();
        return null;
      }
    },
    // 设置缓存数据
    setCachedRegionData(data) {
      try {
        const expiryTime = Date.now() + CACHE_DURATION;
        const encodedData = encodeURIComponent(JSON.stringify(data));
        localStorage.setItem(CACHE_KEY, encodedData);
        localStorage.setItem(CACHE_EXPIRY_KEY, expiryTime.toString());
      } catch (error) {
        console.error('存储失败，请联系管理员！', error);
        clearRegionCache();
      }
    },
    // 清理缓存
    clearRegionCache() {
      localStorage.removeItem(CACHE_KEY);
      localStorage.removeItem(CACHE_EXPIRY_KEY);
    }
  }
};
</script>
<style lang="scss" scoped></style>